import {
  LayoutDashboard,
  UserPlus,
  Users,
  MessagesSquare,
  PhoneCall,
  CalendarClock,
  Stethoscope,
  BellRing,
  BookOpen,
  BarChart3,
  Settings,
} from "lucide-react";

export const NAV_ITEMS = [
  { label: "Dashboard", path: "/", icon: LayoutDashboard, testId: "nav-dashboard" },
  { label: "Leads", path: "/leads", icon: UserPlus, testId: "nav-leads" },
  { label: "Patients", path: "/patients", icon: Users, testId: "nav-patients" },
  { label: "Conversations", path: "/conversations", icon: MessagesSquare, testId: "nav-conversations" },
  { label: "Calls", path: "/calls", icon: PhoneCall, testId: "nav-calls" },
  { label: "Appointments", path: "/appointments", icon: CalendarClock, testId: "nav-appointments" },
  { label: "Doctors", path: "/doctors", icon: Stethoscope, testId: "nav-doctors" },
  { label: "Follow-ups", path: "/follow-ups", icon: BellRing, testId: "nav-followups" },
  { label: "Knowledge Base", path: "/knowledge-base", icon: BookOpen, testId: "nav-knowledge-base" },
  { label: "Analytics", path: "/analytics", icon: BarChart3, testId: "nav-analytics" },
  { label: "Settings", path: "/settings", icon: Settings, testId: "nav-settings" },
];
